<div class="wrapper" [ngStyle]="{
    'background-image': 'url(' + (companyData?.companyBackgroundImage ? companyData?.companyBackgroundImage : fallbackCompanyBg)   + ')',
    'border-radius': '0px'
  }" [class.single-section]="isSingleSection()"
  [style.justify-content]="companyData.containerAlignment !== '' && isSingleSection() ?  companyData.containerAlignment : 'center'">
  <div class="sections-wrapper" [style.width]="!isSingleSection() ? '1160px' : ''">
    <!-- Logo For Single Section  -->
    <div class="d-flex justify-content-center mb-3" *ngIf="isSingleSection()">
      <a [attr.href]="isVantixCompany() ? 'https://vantixlogistics.com/' : null"
        [attr.target]="isVantixCompany() ? '_blank' : null"
        [attr.rel]="isVantixCompany() ? 'noopener noreferrer' : null">
        <img [src]="companyData?.companyLogo ? companyData.companyLogo : fallbackLogo" alt="co_logo" class="company-logo-oneSection" />
      </a>
    </div>
    <div class="login-content" [class.custom-width]="isSingleSection()" [class.custom-login-section-padding]="
        checkIfLoginAccessEnabled() && !checkIfTrackingEnabled()
      "[class.custom-track-section-padding]="
        !checkIfLoginAccessEnabled() && checkIfTrackingEnabled()
      "[style.border-radius]="isSingleSection() ? '7px' : isMobile?'7px':'20px'">
      <!-- Logo  -->
      <div class="d-flex justify-content-center" *ngIf="!isSingleSection() || isMobile">
        <a [attr.href]="isVantixCompany() ? 'https://vantixlogistics.com/' : null"
          [attr.target]="isVantixCompany() ? '_blank' : null"
          [attr.rel]="isVantixCompany() ? 'noopener noreferrer' : null">
          <img [src]="(companyData?.companyLogo ? companyData.companyLogo : fallbackLogo)" alt="co_logo" class="company-logo" />
        </a>
      </div>
      <!-- Top Buttons (visible only on mobile), Only show if both Login and Tracking Access is enabled.-->
      <div class="toggle-buttons mt-3" [class.d-none]="
          !checkIfLoginAccessEnabled() || !checkIfTrackingEnabled()
        ">
        <button type="button" class="btn btn-danger" (click)="activeSection = 'track'"
          [class.active]="activeSection === 'track'">
          Track
        </button>
        <button type="button" class="btn hidden btn-success" (click)="activeSection = 'login'"
          [class.active]="activeSection === 'login'">
          Login
        </button>
      </div>

      <div class="grid-container" [class.has-divider]="
          checkIfLoginAccessEnabled() && checkIfTrackingEnabled()
        ">
        <!-- Track Section  -->
        <div *ngIf="checkIfTrackingEnabled()" class="track-section"
          [class.active]="activeSection === 'track' || isDesktop">
          <div class="h-100 d-flex flex-column justify-content-lg-between">
            <div class="d-flex flex-column align-items-center">
              <h3 class="mb-2 title" [style.color]="companyData?.brandColor">
                Track Your Shipment
              </h3>
              <p class="mb-3 subtitle">(No Login Required)</p>
            </div>

            <form class="track-form mb-3">
              <input [(ngModel)]="shipmentRefrenceNumber" name="track-shipment" type="text" class="bottom-border-input"
                placeholder="Enter your Reference Number(s) here." [ngStyle]="{
                  'border-bottom': '1.5px solid ' + companyData?.brandColor
                }" />
            </form>
            <!-- Info Div  -->
            <div class="info-section" [style.backgroundColor]="
                companyData?.brandColor ? companyData?.brandColor + '80' : ''
              ">
              Enter your Reference Number(s) above. You may enter up to 20
              space-separated values.Only the following reference types are
              supported for shipment tracking, as enabled by your provider:
              <div class="ref-types-wrapper">
                <div class="ref-type tooltip-wrapper" [class.show]="showTooltip" (mouseenter)="onHover(true)"
                  (mouseleave)="onHover(false)" (click)="onClick()">
                  <span class="ellipsis-text">
                    {{ formatSecondaryTypeNames() }}</span>
                  <div class="tooltip-text" *ngIf="showTooltip">
                    {{ formatSecondaryTypeNames() }}
                  </div>
                </div>
              </div>
              <p>
                Reference numbers must match the enabled types exactly. If the
                reference type is not supported, tracking information will not
                be available.
              </p>
            </div>
            <button class="login-s-button" (click)="trackShipment()" [disabled]="!shipmentRefrenceNumber"
              [style.backgroundColor]="companyData?.brandColor">
              Track
            </button>
          </div>
        </div>
        <!-- Login Section  -->
        <div *ngIf="checkIfLoginAccessEnabled()" class="login-section"
          [class.active]="activeSection === 'login' || isDesktop"
          [style.margin-left]="!checkIfTrackingEnabled() ? '0rem' : '4rem'">
          <div class="h-100 d-flex flex-column justify-content-lg-between">
            <div class="d-flex flex-column align-items-center">
              <h3 class="mb-4 title text-center" [style.color]="companyData?.brandColor">
                Customer Portal <br />
                Login
              </h3>
            </div>
            <form class="customer-login-form" [formGroup]="loginForm" (ngSubmit)="submitLoginForm()">
              <!-- Email  -->
              <div>
                <label for="email" class="d-none d-md-block mb-2">Email</label>
                <div class="field-container" [ngClass]="{
                    'error-border':
                      getControl('loginEmail').hasError('required') &&
                      getControl('loginEmail').touched
                  }" [ngStyle]="{
                    border: '1.5px solid ' + companyData?.brandColor
                  }">
                  <span class="field-icon">
                    <i class="bi bi-envelope" style="text-shadow: 0 0 1px currentColor"
                      [style.color]="companyData?.brandColor"></i>
                  </span>
                  <input type="email" id="email" class="login-input" placeholder="Enter your email"
                    formControlName="loginEmail" />
                </div>
                <!-- Field Error  -->
                <p class="error" *ngIf="
                    getControl('loginEmail').hasError('required') &&
                    getControl('loginEmail').touched
                  ">
                  This field is required
                </p>
                <p class="error" *ngIf="
                    getControl('loginEmail').hasError('pattern') &&
                    getControl('loginEmail').touched
                  ">
                  Please enter a valid email address
                </p>
              </div>

              <!-- Password  -->
              <div>
                <label for="Password" class="d-none d-md-block mb-2">Password</label>
                <div class="field-container" [ngClass]="{
                    'error-border':
                      getControl('loginPassword').hasError('required') &&
                      getControl('loginPassword').touched
                  }" [ngStyle]="{
                    border: '1.5px solid ' + companyData?.brandColor
                  }">
                  <span class="field-icon">
                    <i class="bi bi-lock" style="text-shadow: 0 0 1px currentColor"
                      [style.color]="companyData?.brandColor"></i>
                  </span>
                  <input [type]="isPasswordVisible ? 'text' : 'password'" id="password" class="login-input"
                    placeholder="Enter your password" formControlName="loginPassword" />
                  <span (click)="togglePasswordVisibility()" class="password-toggle-icon" id="togglePassword">
                    <i class="bi" [ngClass]="
                        isPasswordVisible ? 'bi-eye-slash-fill' : 'bi-eye-fill'
                      " style="font-size: 20px"></i>
                  </span>
                </div>
                <!-- Field Error  -->
                <p class="error" *ngIf="
                    getControl('loginPassword').hasError('required') &&
                    getControl('loginPassword').touched
                  ">
                  This field is required
                </p>
                <a (click)="forgotPassword()" class="link-style">Forgot Password?</a>
              </div>
              <!-- Login Button  -->
              <div class="position-relative">
                <button class="login-s-button" [style.backgroundColor]="companyData?.brandColor">
                  Login
                </button>
                <a class="link-style w-100 text-center position-absolute top-0">Don’t have an account yet?
                  <span [style.color]="companyData?.brandColor">Request Access</span></a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>